<template>
  <div class="article-wrapper__body">
    <aside class="shortlinks" ref="shortlinks">
      <nav
        role="navigation"
        :aria-label="ariaLabel"
        class="shortlinks__sidebar"
      >
        <ul id="shortlinks"></ul>
      </nav>
      <slot name="social-media"></slot>
    </aside>
    <article class="editor-component">
      <slot name="editor-component"></slot>
    </article>
  </div>
</template>
<script>
export default {
  name: 'article-section',
  mounted() {
    const shortlinksParent = document.getElementById('shortlinks');
    const editorialSections = document.querySelectorAll(
      '.editorcomponent-container'
    );
    const items = [];

    editorialSections.forEach((section) => {
      const header = section.querySelector('h2');
      if (!header) return;

      let title = header.innerHTML.trim();

      if (!section.getAttribute('id')) {
        section.id = title.toLowerCase().replace(/ /g, '-');
      }

      const li = document.createElement('li');
      li.className = 'shortlinks__sidebar-item';
      const a = document.createElement('a');
      a.href = `#${section.id}`;

      a.addEventListener('click', function () {
        let taggingData = {
          event: 'uaevent',
          event_name: 'body_button_click',
          ecommerce: 'undefined',
          cta_name: title.toLowerCase(),
          link_url: a.href,
          module_name: 'shortlinks',
        };
        window.dataLayer.push(taggingData);
      });

      a.textContent = title;
      li.appendChild(a);
      shortlinksParent.appendChild(li);
      items.push(a);
    });

    window.addEventListener('scroll', () => {
      let current = '';
      let lastElementIndex = editorialSections.length - 1;
      editorialSections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (pageYOffset >= sectionTop - 100) {
          current = section.getAttribute('id');
        }
      });

      let lastElement =
        editorialSections[lastElementIndex].getBoundingClientRect();
      let elemTop = lastElement.top;
      let elemBottom = lastElement.bottom;
      let articleContainer = document.querySelector(
        '.article-wrapper__body aside'
      );

      if (elemTop <= 95) {
        articleContainer.style.position = 'sticky';
      }
      if (elemBottom <= 0) {
        articleContainer.style.position = 'unset';
      }

      items.forEach((link) =>
        link.classList.toggle(
          'active',
          link.getAttribute('href') === `#${current}`
        )
      );
    });
  },
  data() {
    return {
      isPageScrolled: false,
      timeInterval: null,
      timing: 0,
      isTimeLimitCrossed: false,
      isDataLayerPushed: false,
    };
  },
  props: {
    ariaLabel: {
      type: String,
      required: true,
      default: 'Table of contents',
    },
  },
};
</script>
<style></style>
